@if (button) {
  <button mat-stroked-button (click)="button.action()">
    {{ button.label }}
  </button>
}
@if (button) {
  <button
    type="button"
    [matTooltip]="button.tooltip"
    matTooltipPosition="below"
    class="tip-icon-button"
    [attr.aria-label]="button.tooltip || button.label"
  >
    <mat-icon class="mat-icon material-icons md-18">info</mat-icon>
  </button>
}
